
import { useState } from 'react'
import Y from '../../pages/ListDam.module.css'
import G from '../../images/userr.png'
import D from '../../pages/Settings.module.css'
import { Pagination } from '@mui/material';
import AdminListCard from '../cardThemes/AdminListCard.js' 
import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline';
import F from '../../pages/ListDam.module.css';
import ReportIcon from '@mui/icons-material/Report';
import {useDispatch} from 'react-redux'
import { useSelector } from 'react-redux';
import { useEffect } from 'react';
import AddAdmin from '../AddNewAdmin.js'
import InfoIcon from '@mui/icons-material/Info';

import { Person3Rounded, SplitscreenOutlined, TitleRounded,ChangeHistory, Info } from '@mui/icons-material';
import Title from '@mui/icons-material/Title';
import { Switch } from '@mui/material';
import {getAdmins} from '../../redux/slices/adminSlice.js'
import { useGlobalContext } from '../Context';
import apiService from '../../api/ApiService';
import EmptyReturn from '../EmptyReturn';
import { Link } from 'react-router-dom';
import EditUserInfo from '../editUserInfo.js';
const a=[
  {comp:'فعال'},{comp:'غیر فعال'}
]

const Admins=()=>{
  const [Value,setValue]=useState(0)
    const {openWarn,closeWarn,isModalWarnOPen,openModalls2,isOpenModal2}=useGlobalContext();
    const [tempData,setTempData]=useState('')
    const [iindex,setIindex]=useState(0)
    const {currentAdmin,currentTheme,currentAdmins}=useSelector(state=>state.p.admin)
    const [page,setPage]=useState(0)
    const [total,setTotal]=useState(0);
    const dispatch=useDispatch()
    const toggleUser=async(id,index)=>{
      const res=await apiService.toggleUser(id);
      const editedList = [
        ...currentAdmins.slice(0,index),
        res.data,
        ...currentAdmins.slice(index+1)
      ];
      dispatch(getAdmins(editedList))

    }
    const getAllAdmins=async()=>{
      const data=JSON.stringify({
        "skip": page?(page-1)*8:0,
        "take": 8,
        "fromDate": null,
        "toDate": null,
        "farmId": null,
        "isActive": Value==0?true:false
      })
      const res=await apiService.getAdmins(data);
      dispatch(getAdmins(res.data?.data))
      setTotal(Math.ceil(res.data.totalCount/8))

    }
    const handlePage = (event, value) => {
      setPage(value);
    };
    useEffect(()=>{
      getAllAdmins()
    },[Value])
return <>
<div className={D.Settingcontainer}>
<div style={{display:'flex',justifyContent:'space-between',alignItems:'center',width:'100%'}}>
<div className={Y.TabForAllAnnimbtnLICon}>
            {a.map((item,index)=>{
              return <div key={index} className={`${Y.jobbtnLItab} ${index === Value && Y.ActiveLITab}`} onClick={()=>setValue(index)} >{item.comp}</div>
              

            })}
          </div>
        <div style={{display:'flex',justifyContent:'space-between'}}>
        
        <div onClick={openWarn} data-title='افزودن کاربر جدید' className={`${F.CreateNewFarmBtn}`}>
                <AddCircleOutlineIcon sx={{fontSize: { xs: 26, sm: 30, md: 30, lg:30} }}/>
        </div>
           
        </div>
      </div>
      <div className={Y.TabForAllAnnimLICon}>
          
          {!currentTheme&&<div className={Y.AnimContentLI} data-aos='fade'>
          {currentAdmins?.length?<table>
              <thead>
              <tr>
                  <th>
                  <div className='LogoFormT'><div><span>
                <SplitscreenOutlined/>
                </span>
                    </div></div>
                  </th>
                  <th>
                  <div className='LogoFormT'><div><span>
                <TitleRounded/>
                </span>
                    </div></div>
                  </th>
                  <th>
                  <div className='LogoFormT'><div><span>
                <Title/>
                </span>
                    </div></div> 
                  </th>
                  <th>
                  <div className='LogoFormT'><div><span>
                <Person3Rounded/>
                </span>
                    </div></div>
                  </th>
                  <th>
                  <div className='LogoFormT'><div><span>
                <ReportIcon/>
                </span>
                    </div></div>
                  </th>
                  <th>
                  <div className='LogoFormT'><div><span>
                <Info/>
                </span>
                    </div></div>
                  </th>
                  {/* <th>
                  <div className='LogoFormT'><div><span>
                <ChangeHistory/>
                </span>
                    </div></div>
                  </th> */}
                </tr>
                <tr>
                  <th>
                    ردیف
                  </th>
                  <th>
                     نام
                  </th>
                  <th>
                    موضوع 
                  </th>
                  <th>
                     نقش
                  </th>
                  <th>
                    فعال / غیر فعال
                  </th>
                  <th>
                      تغییر مشخصات
                  </th>
                  {/* <th>
                    تغییر  مشخصات
                  </th> */}
                </tr>
              </thead>
              <tbody>
                {
                  currentAdmins?.length&&currentAdmins?.map((item,index)=>{
                  
                    return <tr key={index}>
                    <td>
                      {index+1}
                    </td>
                    <td>
                      {item.username}
                    </td>
                    <td>
                      {item.title}
  
                    </td>
                    <td>
                      {item.role}
  
                    </td>
                    <td >
                <Switch color="success" checked={item?.isActive} onChange={()=>toggleUser(item.id,index)} />

                    </td>
                    <td className={Y.DetIc}>
                      <Link onClick={()=>{openModalls2();setIindex(index);setTempData(item)}}>
                      <div className='btnCardDAm'>تغییر</div>

                      </Link>
                    </td>
                  </tr>
                  
                  })
                }
                
                
                
                
                

              </tbody>
            </table>:<EmptyReturn/>}
          </div>}
          {currentTheme&&<AdminListCard/>}
        </div>
        <div className='PaginateContainer'>
            <Pagination defaultPage={1} count={total} page={page==0?page+1:page} onChange={handlePage} variant="outlined" color="primary"  boundaryCount={2}/>
            </div>
        {!currentTheme&&isOpenModal2&&<EditUserInfo data={tempData} iindex={iindex} flag={'editAdmin'}/>}
        {isModalWarnOPen&&<AddAdmin/>}
</div>

</>
}
export default Admins